import { ArrowDownDark, FileTemplateExport } from '@icons';
import { downloadChecklist, downloadChecklistHistory, getChecklist } from '@lib/api';
import { useMutation, useQuery } from '@tanstack/react-query';
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import SummaryDownloadBox from './SummaryDownloadBox';

type EntityType = {
	entityType: string;
	entityId: string | number;
	label: string;
};

interface SummaryDownloadListProps {
	entity: EntityType;
	extraEntity?: EntityType;
	hasStandardChecklist?: boolean;
}

const SummaryDownloadList: React.FC<SummaryDownloadListProps> = ({ entity, extraEntity, hasStandardChecklist }) => {
	const [isListOpen, setIsListOpen] = useState(false);
	const { entityType, entityId, label } = entity;

	const { data: checklistData } = useQuery({
		queryKey: ['checklist', entityType, entityId],
		queryFn: () => getChecklist(entityType, entityId),
		select: (data) => data.data,
	});

	const downloadChecklistMutation = useMutation({
		mutationFn: () => downloadChecklist([entityType, entityId, false]),
	});
	const downloadStandardChecklistMutation = useMutation({
		mutationFn: () => downloadChecklist([entityType, entityId, true]),
	});
	const downloadChecklistHistoricMutation = useMutation({
		mutationFn: () => downloadChecklistHistory(checklistData.id),
	});

	const checklistsToDownload = [
		{
			key: 'working',
			label: (
				<span
					style={{
						fontWeight: 700,
					}}
				>
					{entity.entityType === 'tenders' || entity.entityType === 'frameworkcontracts'
						? 'Checklist di lavoro'
						: `
					Checklist ${label}
					 `}
				</span>
			),
			mutation: downloadChecklistMutation,
		},
		...(hasStandardChecklist
			? [
					{
						key: 'standard',
						label: (
							<span
								style={{
									fontWeight: 700,
								}}
							>
								Checklist standard
							</span>
						),
						mutation: downloadStandardChecklistMutation,
					},
				]
			: []),
		{
			key: 'historic',
			label: (
				<span
					style={{
						fontWeight: 700,
					}}
				>
					Checklist {label}{' '}
					<span
						style={{
							fontWeight: 400,
						}}
					>
						- Storico delle risposte
					</span>
				</span>
			),
			mutation: downloadChecklistHistoricMutation,
		},
	];

	const extraChecklistData = useQuery({
		queryKey: ['checklist', extraEntity?.entityType, extraEntity?.entityId],
		queryFn: () => getChecklist(extraEntity.entityType, extraEntity.entityId),
		enabled: !!extraEntity,
		select: (data) => data.data,
	});

	const extraDownloadChecklistMutation = useMutation({
		mutationFn: () => downloadChecklist([extraEntity.entityType, extraEntity.entityId, false]),
	});

	const extraDownloadChecklistHistoricMutation = useMutation({
		mutationFn: () => downloadChecklistHistory(extraChecklistData.data.id),
	});

	const extraChecklistsToDownload = extraEntity
		? [
				{
					key: 'extra-working',
					label: (
						<span
							style={{
								fontWeight: 700,
							}}
						>
							Checklist {extraEntity.label}
						</span>
					),
					mutation: extraDownloadChecklistMutation,
				},
				{
					key: 'extra-historic',
					label: (
						<span
							style={{
								fontWeight: 700,
							}}
						>
							Checklist {extraEntity.label}{' '}
							<span
								style={{
									fontWeight: 400,
								}}
							>
								- Storico delle risposte
							</span>
						</span>
					),
					mutation: extraDownloadChecklistHistoricMutation,
				},
			]
		: [];

	return (
		<>
			<Button
				onClick={() => {
					setIsListOpen(true);
				}}
				className="btn custom-ghost-button"
				style={{
					// color: '#06797F',
					textTransform: 'none',
					height: 'auto',
					display: 'flex',
					alignItems: 'center',
					gap: '0.5rem',
				}}
			>
				scarica in formato excel{' '}
				<ArrowDownDark
				// style={{
				// 	fill: '#06797F',
				// }}
				/>
			</Button>
			{isListOpen ? (
				<div
					style={{
						position: 'absolute',
						inset: 0,
						zIndex: 9999,
						padding: '2rem',
					}}
				>
					<div
						style={{
							backgroundColor: '#fff',
							height: '100%',
							borderRadius: '8px',
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'center',
							// placeContent: 'center',
						}}
					>
						<div style={{ display: 'grid', placeItems: 'center', gap: '1rem' }}>
							<FileTemplateExport style={{ fill: '#1C2743' }} />
							<h4
								style={{
									fontWeight: 700,
								}}
							>
								scarica in formato excel
							</h4>
							<p>Scegli la versione di cui hai bisogno</p>
						</div>
						<div style={{ display: 'grid', placeContent: 'center', gridTemplateColumns: '1fr', gap: '1rem', marginBlock: '2rem' }}>
							{checklistsToDownload.map((checklist) => (
								<SummaryDownloadBox key={checklist.key} checklist={checklist} />
							))}

							{extraEntity
								? extraChecklistsToDownload.map((checklist) => <SummaryDownloadBox key={checklist.key} checklist={checklist} />)
								: null}

							{/* <div
								style={{
									padding: '1rem',
									border: '1px solid #2A3A64',
									borderRadius: '8px',
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'center',
									maxWidth: '800px',
									width: '100%',
									margin: '0 auto',
								}}
							>
								<span>Checklist {label}</span>
								<Button
									onClick={() => {
										downloadChecklistMutation.mutate();
									}}
									className="btn custom-primary-button"
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										gap: '0.5rem',
										minWidth: '175px',
										height: '48px',
									}}
								>
									<IcoDownloadCloudArrowSmall />
									Scarica
								</Button>
							</div> */}
						</div>
						<div style={{ display: 'grid', placeContent: 'center' }}>
							<Button
								onClick={() => {
									setIsListOpen(false);
								}}
								className="btn custom-ghost-button"
								style={{
									textTransform: 'none',
									color: '#06797F',
									fontWeight: 500,
									display: 'flex',
									alignItems: 'center',
									gap: '0.5rem',
								}}
							>
								<ArrowDownDark
									style={{
										fill: '#06797F',
										rotate: '90deg',
									}}
								/>
								torna alle domande
							</Button>
						</div>
					</div>
				</div>
			) : null}
		</>
	);
};

export default SummaryDownloadList;
